// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__EFmSb","selects":"Documents_selects__1qnAn"};